import { _RULES } from "@/store/_RULES"
import { _GROUPS } from "@/store/_PERMISSIONS"

// -- FIELDS
const _FIELDS = [
  {
    label: "Email",
    name: "email",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required, _RULES.email]
  },
  {
    title: "Data",
    type: "data",
    name: "data",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required]
  },
  {
    label: "NIF",
    name: "nif",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required]
  },
  {
    label: "Valor",
    name: "valor",
    type: "text",
    size: {
      cols: 6,
      sm: 6,
      md: 6
    },
    rules: [_RULES.required, _RULES.isFloat]
  },
  {
    label: "Morada",
    name: "morada",
    type: "text",
    size: {
      cols: 12,
      sm: 12,
      md: 12
    },
    rules: []
  }
]

// -- HEADERS
const _HEADERS = [
  {
    text: "Nome",
    align: "left",
    value: "nome"
  },
  {
    text: "Valor",
    align: "left",
    value: "valor"
  },
  {
    text: "Data",
    align: "left",
    value: "data"
  },
  {
    text: "Ações",
    value: "action"
  }
]

const DONATIVO = {
  _FIELDS: _FIELDS,
  _HEADERS: _HEADERS
}

export default DONATIVO
